import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const fetchMessageRequest = () => ({
  type: actionTypes.FETCH_MESSAGE_REQUEST,
  name: 'messageDetailsLoadingStatus',
});

export const fetchMessageFailure = () => ({
  type: actionTypes.FETCH_MESSAGE_FAILURE,
  name: 'messageDetailsLoadingStatus',
});

export const fetchMessageSuccess = (message) => ({
  type: actionTypes.FETCH_MESSAGE_SUCCESS,
  name: 'messageDetailsLoadingStatus',
  message,
});

export const fetchMessage = (id) => async (dispatch) => {
  try {
    dispatch(fetchMessageRequest());
    const message = await api.fetchMessage(id);

    dispatch(fetchMessageSuccess(message));
  } catch (error) {
    dispatch(fetchMessageFailure(error));
    console.error('FETCH_MESSAGE', error);
  }
};

export const fetchSentMessage = (id) => async (dispatch) => {
  try {
    dispatch(fetchMessageRequest());
    const message = await api.fetchSentMessage(id);
    dispatch(fetchMessageSuccess(message));
  } catch (error) {
    dispatch(fetchMessageFailure(error));
    console.error('FETCH_MESSAGE', error);
  }
};

export const fetchSentMessageDetails = (id) => async (dispatch) => {
  try {
    dispatch(fetchMessageRequest());
    const message = await api.fetchSentMessageDetails(id);

    dispatch(fetchMessageSuccess(message));
  } catch (error) {
    dispatch(fetchMessageFailure(error));
    console.error('FETCH_MESSAGE', error);
  }
};

export const clearSelectedMessage = () => ({
  type: actionTypes.CLEAR_SELECTED_MESSAGE,
});



// WEBPACK FOOTER //
// ./src/modules/message/actions/message-details.actions.js